import { useMutation } from "@apollo/client/react";
import { StartAiImportDocument, StartAiImportMutation, StartAiImportMutationVariables } from "@/graphql/__generated__/graphql";

/**
 * Custom hook for starting the ai import.
 * @returns {Object} - Contains the startAIImport function, loading state, and error state.
 */
export default function useStartAIImportHook(): { startAIImport: any, loading: any, error: any} {
  const [startAIImport, { loading, error }] = useMutation<StartAiImportMutation, StartAiImportMutationVariables>(StartAiImportDocument);

  return {
    startAIImport,
    loading,
    error
  };
}
